'use strict';

// Instance Methods
require('../string/humanize');
require('../string/pluralize');
require('../string/singularize');

// Accessors
require('../string/addAcronym');
require('../string/addHuman');
require('../string/addPlural');

module.exports = require('sugar-core');